import { useMutation } from "@tanstack/react-query";

import { EnrollMfaRequest, EnrollMfaResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useEnrollMfa = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation(
    (body: EnrollMfaRequest): Promise<EnrollMfaResponse> =>
      fetch(ENDPOINTS.mfa.enroll, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
    {
      onError: (error: string) => {
        displayErrorToast(error);
      },
    },
  );
};
